module.exports = __webpack_public_path__ + "static/media/Kimmy Design - CatalinaClementeLight.c2993e02.otf";